import { v4 } from 'uuid';

export const getNodeID = v4;
export const getOptionID = v4;

export const getEdgeID = (sourceID: string, targetID: string, sourceHandleID?: string | null): string =>
  `reactflow__edge-${sourceID}${(sourceHandleID) ? sourceHandleID : sourceID}-${targetID}${targetID}`;
